import Box from '@material-ui/core/Box';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';
import Filters from './Filters';
import { columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}/style`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({ Styled, i18n, pagination, changeRequest, request, eventData, hasSaveApiStatus, setPagination }) => {
  const generateRows = () => {
    return (
      eventData?.eventInfoList?.map((e) => {
        return {
          event_type: e?.eventType,
          count: e?.eventCount,
          last_occurence: moment(e?.lastOccurrenceTime).format('DD-MM-YYYY HH:MM:SS A'),
        };
      }) || []
    );
  };

  const [values, setInitialValues] = useState({
    eventType: null,
  });

  return (
    <>
      <Styled.Wrapper>
        <Styled.BottomWrapper>
          <div>
            <Label>
              Vehicle Name:{' '}
              <span style={{ fontWeight: '800', fontSize: 'larger' }}>{eventData?.eventInfoList?.[0]?.vehicleName || ''}</span>
            </Label>
          </div>
          <Styled.TableWrapper>
            <Filters
              handleReset={() => {
                changeRequest({});
                setInitialValues({
                  eventType: null,
                });
              }}
              values={values}
              filterList={(e) => {
                changeRequest(e);
              }}
              setInitialValues={setInitialValues}
            />
            <Table
              type="server"
              defaultSortBy={{ sortBy: 'event_type', order: 'asc' }}
              title=""
              changeRequest={changeRequest}
              baseRequest={request}
              totalRecords={eventData?.totalElements}
              columns={columns}
              data={generateRows()}
              emptyMessage={i18n.t('common.tableEmptyMessage')}
              itemsPerPage={10}
              actions={[]}
              defaultSort={'event_type'}
              i18n={i18n}
              pageinationReset={pagination}
              pagenationClicked={(e) => {
                setPagination(!e);
              }}
            />
          </Styled.TableWrapper>
          {typeof hasSaveApiStatus?.errorMessage === 'string' && (
            <Message type="error" asTags message={i18n.t(hasSaveApiStatus.errorMessage)} />
          )}
        </Styled.BottomWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};
